import React, { useEffect, useMemo } from 'react';
import styles from './CaptureForm.module.scss';
import { useFormikContext } from 'formik';
import RadioGroup from 'component/atom/forms/radio-group/RadioGroup';
import EntireUserReply from './components/EntireUserReply';
import Entities from './components/Entities';

const CaptureForm = ({ data, isFetching }) => {
  const formik = useFormikContext();

  const radioOptions = [
    { label: 'Entire User Reply', value: '0' },
    { label: 'Entities', value: '1' },
  ];

  const items = data?.data?.items || [];

  const selectedVariableLabel = useMemo(() => {
    if (!items?.length) return '';
    const match = items.find(
      (item) => item.variableId == formik.values.variableId,
    );
    return match?.variableName || '';
  }, [items, formik.values.variableId]);

  useEffect(() => {
    if ((formik.values.variableLabel || '') !== (selectedVariableLabel || '')) {
      formik.setFieldValue('variableLabel', selectedVariableLabel || '');
    }
  }, [selectedVariableLabel, formik.values.variableLabel]);

  useEffect(() => {
    if (formik.values.isEntities && formik.values.selectedTab !== '1') {
      formik.setFieldValue('selectedTab', '1');
    }
    if (!formik.values.isEntities && formik.values.selectedTab !== '0') {
      formik.setFieldValue('selectedTab', '0');
    }
  }, [formik.values.isEntities, formik.values.selectedTab]);

  return (
    <form
      className={styles['capture-form']}
      onSubmit={formik.handleSubmit}
      onKeyDown={(e) => e.key === 'Enter' && e.preventDefault()}
    >
      <RadioGroup
        options={radioOptions}
        selectedValue={formik.values.selectedTab}
        onChange={(e) => {
          const nextTab = e.target.value;
          formik.setFieldValue('selectedTab', nextTab);
          formik.setFieldValue('isEntities', nextTab === '1');
        }}
      />

      {formik.values.selectedTab === '0' ? (
        <EntireUserReply formik={formik} data={data} isFetching={isFetching} />
      ) : (
        <Entities formik={formik} data={data} />
      )}
    </form>
  );
};

export default CaptureForm;
